import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import startcase from 'lodash.startcase';

import request from 'services/request';
import Box from 'grommet/components/Box';
import Section from 'grommet/components/Section';
import Article from 'grommet/components/Article';
import FormField from 'grommet/components/FormField';
import Header from 'grommet/components/Header';
import Footer from 'grommet/components/Footer';
import Anchor from 'grommet/components/Anchor';
import Button from 'grommet/components/Button';
import Notification from 'grommet/components/Notification';
import Title from 'grommet/components/Title';
import Form from 'grommet/components/Form';
import Heading from 'grommet/components/Heading';
import Login from 'grommet/components/icons/base/Login';
import Spinning from 'grommet/components/icons/Spinning';

import counties from 'utils/counties';
import allUnset from 'utils/allUnset';

import Applications from 'components/Applications';
import Datepicker from 'elements/Datepicker';
import TextInput from 'elements/TextInput';
import Select from 'elements/Select';

export const SECTIONS = {
  FALL: {
    FORMS: [
      'fall_MAP',
      'fall_DAP',
      'fall_NH3',
      'fall_urea',
      'fall_UAN28',
      'fall_UAN32',
      'fall_manure_animal',
      'fall_manure_gallons',
      'fall_manure_tons',
      'fall_pounds_n_manure',
      'fall_manure_analysis',
      'fall_manure_application_date',
    ],
    MANURE: [
      'fall_manure_animal',
      'fall_manure_gallons',
      'fall_manure_tons',
      'fall_pounds_n_manure',
      'fall_manure_analysis',
      'fall_manure_application_date',
    ],
    DATES: [
      'application_date_fall',
    ]
  },
  SPRING: {
    FORMS: [
      'spring_MAP',
      'spring_DAP',
      'spring_starter',
      'spring_starter_analysis',
      'spring_NH3',
      'spring_urea',
      'spring_UAN28',
      'spring_UAN32',
      'spring_manure_animal',
      'spring_manure_gallons',
      'spring_manure_tons',
      'spring_pounds_n_manure',
      'spring_manure_analysis',
      'spring_manure_application_date',
    ],
    MANURE: [
      'spring_manure_animal',
      'spring_manure_gallons',
      'spring_manure_tons',
      'spring_pounds_n_manure',
      'spring_manure_analysis',
      'spring_manure_application_date',
    ],
    DATES: [
      'application_date_spring',
    ],
  },
  IN_SEASON: {
    FORMS: [
      'in_season_MAP',
      'in_season_DAP',
      'in_season_NH3',
      'in_season_urea',
      'in_season_UAN28',
      'in_season_UAN32',
    ],
    DATES: [
      'application_date_in_season',
    ],
  },
};

export const fallForms = prefix => SECTIONS.FALL.FORMS.map(form => `${prefix}_${form}`);
export const fallDates = prefix => SECTIONS.FALL.DATES.map(date => `${prefix}_${date}`);
export const fallManure = prefix => SECTIONS.FALL.MANURE.map(form => `${prefix}_${form}`);

export const springForms = prefix => SECTIONS.SPRING.FORMS.map(form => `${prefix}_${form}`);
export const springDates = prefix => SECTIONS.SPRING.DATES.map(date => `${prefix}_${date}`);
export const springManure = prefix => SECTIONS.SPRING.MANURE.map(form => `${prefix}_${form}`);

export const inSeasonForms = prefix => SECTIONS.IN_SEASON.FORMS.map(form => `${prefix}_${form}`);
export const inSeasonDates = prefix => SECTIONS.IN_SEASON.DATES.map(date => `${prefix}_${date}`);

export const spring = prefix => springForms(prefix).concat(springDates(prefix));
export const fall = prefix => fallForms(prefix).concat(fallDates(prefix));
export const inSeason = prefix => inSeasonForms(prefix).concat(inSeasonDates(prefix));

export default class extends Component {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.onReset = this.onReset.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onChangeDate = this.onChangeDate.bind(this);
    this.toggleSection = this.toggleSection.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
    this.showFirstError = this.showFirstError.bind(this);

    this.initialState = () => ({
      field: {
        overview_county: '',
      },
      standard_fall: false,
      standard_spring: false,
      standard_in_season: false,

      mrtn_fall: false,
      mrtn_spring: false,
      mrtn_in_season: false,

      global_error: null,
      errors: {},
    });

    this.state = this.initialState();
  }

  toggleSection(isOpen, sectionName, fieldName) {
    this.setState({ [sectionName]: isOpen }, () => {
      if (!Array.isArray(fieldName)) fieldName = [fieldName];
      let simulatedEvents = []
      fieldName.forEach(n => {
        simulatedEvents.push({
          target: {
            name: n,
            value: isOpen ? undefined : null,
          }
        })
        this.onChange(simulatedEvents);
      });
    });
  }

  onSubmit(e) {
    if (this.state.submitting) return false;
    
    const DB_DATE = 'YYYY-MM-DD';
    e.preventDefault();
    const isValid = this.validate();
    if (!isValid) return;

    const body = {...this.state.field};

    this.setState({ global_error: '', submitting: true });

    const dates = [
      'overview_plant_date',

      'standard_application_date_spring',
      'standard_application_date_fall',
      'standard_application_date_in_season',
      'standard_fall_manure_application_date',
      'standard_spring_manure_application_date',

      'mrtn_application_date_spring',
      'mrtn_application_date_fall',
      'mrtn_application_date_in_season',
      'mrtn_fall_manure_application_date',
      'mrtn_spring_manure_application_date',
    ];

    dates.forEach(date => {
      if (body[date]) body[date] = body[date].format(DB_DATE);
    })

    if (body.overview_previousCrop === 'Other') {
        body.overview_previousCrop = body.overview_previousCrop_other;
        body.overview_previousCrop_other = undefined;
    }
    request({
      method: 'POST',
      url: 'api/fields',
      body,
    })
      .then(() => {
        browserHistory.push('/success');
        this.setState({ submitting: false });
      })
      .catch(e => {
        if (e.body.status_code === 422) {
          const errors = Object.keys(e.body.errors).reduce((acc, err) => {
            acc[err] = e.body.errors[err][0];
            return acc;
          }, {});
          return this.setState({ errors }, this.showFirstError);
        }
        // this.setState({ global_error: e.body.message });
        this.setState({
          global_error: 'Something went wrong. Please check your data and try again.',
          submitting: false,
        });
        document.body.scrollTop = 0;
      });
  }

  onReset(e) {
    e.preventDefault();
    this.setState(this.initialState());
    document.body.scrollTop = 0;
  }

  onChange(e) {
    let nextState = {
      field: this.state.field,
      errors: this.state.errors,
    };
    if (Array.isArray(e)) {
      e.forEach(event => {
        const { name, value } = event.target;
        nextState.field[name] = value;
        nextState.errors[name] = '';
      });
    } else {
      const { name, value } = e.target;
      nextState.field[name] = value;
      nextState.errors[name] = '';
    }
    this.setState(nextState);
  }

  onChangeDate(name) {
    return (value) => {
      this.onChange({ target: { name, value } });
    }
  }

  onFocusChange(name) {
    return ({ focused }) => {
      this.setState({ [`${name}Focused`]: focused });
    }
  }

  validate() {
    const { field } = this.state;
    const REQ = 'required';
    const errors = {};

    if (!field.overview_county) errors.overview_county = REQ;
    if (!field.overview_previousCrop) errors.overview_previousCrop = REQ;
    if (field.overview_previousCrop === 'Other') {
      if (!field.overview_previousCrop_other) {
        errors.overview_previousCrop_other = REQ;
      }
    }

    ['standard', 'mrtn'].forEach(section => {
      const forms = {
        FALL: {
          FORMS: fallForms(section),
          MANURE: fallManure(section),
          NON_MANURE: fallForms(section).filter(form => form.indexOf('manure') === -1),
        },
        SPRING: {
          FORMS: springForms(section),
          MANURE: springManure(section),
          NON_MANURE: springForms(section).filter(form => form.indexOf('manure') === -1),
        },
        IN_SEASON: {
          FORMS: inSeasonForms(section),
        },
      };

      ['fall', 'spring', 'in_season'].forEach(season => {
        const sectionNamespace = `${section}_${season}`;

        if (this.state[sectionNamespace]) {
          if (allUnset(field, forms[season.toUpperCase()].FORMS)) {
            errors[sectionNamespace] = `Please specify ${startcase(season)} application details`;
          }
          if (!this.state.field[`${section}_application_date_${season}`] && !allUnset(field, forms[season.toUpperCase()].NON_MANURE)) {
            errors[`${section}_application_date_${season}`] = REQ;
          }
        }
        const manureNamespace = `${sectionNamespace}_manure`;
        if (this.state[manureNamespace]) {
          if (allUnset(field, forms[season.toUpperCase()].MANURE)) {
            errors[manureNamespace] = 'Please specify manure application details';
          }
          if (!this.state.field[`${manureNamespace}_application_date`]) {
            errors[`${manureNamespace}_application_date`] = REQ;
          }
        }
      });

      if (!field[`${section}_yield_rep1`]) errors[`${section}_yield_rep1`] = REQ;
    });

    this.setState({ errors }, this.showFirstError);
    return !Object.keys(errors).length;
  }

  showFirstError() {
    if (Object.keys(this.state.errors)) {
      let error = document.getElementsByClassName('grommetux-form-field--error')[0];
      if (!error) {
        error = document.getElementsByClassName('error')[0];
      }
      if (error) {
        error.scrollIntoView();
      }
    }
  }

  render() {
    const { field, errors, submitting } = this.state;
    return (
      <div>
        <Header
          justify="between"
          size="small"
          colorIndex="brand"
          pad={{horizontal: 'small'}}>
          <Title>4 R Nitrogen Project</Title>
          <Anchor path="/login" icon={<Login />} label="Staff" />
        </Header>
        <Article align="center" pad="medium">
          <Form>
            <Notification
              display-if={this.state.global_error}
              message="Oops!"
              state={this.state.global_error}
              status="critical" />
            <Box>
              <Section pad="none">
                <fieldset>
                  <FormField label="County" error={errors.overview_county}>
                    <Select
                      onChange={this.onChange}
                      value={field.overview_county}
                      name="overview_county"
                      options={counties}
                    />
                  </FormField>
                  <Datepicker
                    label="Planting Date"
                    season="inSeason"
                    id="overview_plant_date"
                    value={field.overview_plant_date}
                    focused={this.state.overview_plant_dateFocused}
                    onDateChange={this.onChangeDate('overview_plant_date')}
                    onFocusChange={this.onFocusChange('overview_plant_date')}
                  />
                  <FormField label="Dominant Soil Type">
                    <TextInput
                      onChange={this.onChange}
                      value={field.overview_soilType}
                      name="overview_soilType" />
                  </FormField>
                  <FormField
                    label="Previous Crop"
                    error={errors.overview_previousCrop}>
                    <select
                      name="overview_previousCrop"
                      onChange={this.onChange}
                      value={field.overview_previousCrop || ''}>
                      <option value="" />
                      <option>Corn</option>
                      <option>Soybean</option>
                      <option>Other</option>
                    </select>
                  </FormField>
                  <FormField
                    display-if={this.state.field.overview_previousCrop === 'Other'}
                    error={this.state.errors.overview_previousCrop_other}
                    label="Specify previous crop"
                  >
                    <TextInput
                      onChange={this.onChange}
                      value={field.overview_previousCrop_other}
                      name="overview_previousCrop_other" />
                  </FormField>
                </fieldset>
              </Section>
              <Applications
                state={this.state}
                onChange={this.onChange}
                onChangeDate={this.onChangeDate}
                onFocusChange={this.onFocusChange}
                name={n => `standard_${n}`}
                value={n => field[`standard_${n}`]}
                heading="My Standard Nitrogen Program"
                toggleSection={this.toggleSection}
                prefix="standard" />
              <Applications
                prefix="mrtn"
                state={this.state}
                onChange={this.onChange}
                onChangeDate={this.onChangeDate}
                onFocusChange={this.onFocusChange}
                name={n => `mrtn_${n}`}
                value={n => field[`mrtn_${n}`]}
                toggleSection={this.toggleSection}
                heading="MRTN Rates Used" />
            </Box>
            <Section pad={{between: 'small'}}>
              <Header
                pad={{ horizontal: 'medium', vertical: 'small' }}
                colorIndex="brand"
                className="sm-margin-top"
                direction="column" align="start">
                <Heading margin="none" tag="h3">Yields</Heading>
              </Header>
              <Box flex>
                <Heading tag="h4">Enter bushels per acre yield by replication for your standard applied rate</Heading>
                <FormField
                  error={this.state.errors.standard_yield_rep1}
                  label="First replication">
                  <TextInput
                    onChange={this.onChange}
                    value={this.state.field.standard_yield_rep1}
                    name="standard_yield_rep1" />
                </FormField>
                <FormField
                  error={this.state.errors.standard_yield_rep2}
                  label="Second replication">
                  <TextInput
                    onChange={this.onChange}
                    value={this.state.field.standard_yield_rep2}
                    name="standard_yield_rep2" />
                </FormField>
                <FormField label="Third replication">
                  <TextInput
                    onChange={this.onChange}
                    value={this.state.field.standard_yield_rep3}
                    name="standard_yield_rep3" />
                </FormField>
              </Box>
              <Box>
                <Heading tag="h4">Enter bushels per acre yield by replication for the MRTN applied rate</Heading>
                <FormField
                  error={this.state.errors.mrtn_yield_rep1}
                  label="First replication">
                  <TextInput
                    onChange={this.onChange}
                    value={this.state.field.mrtn_yield_rep1}
                    name="mrtn_yield_rep1" />
                </FormField>
                <FormField
                  error={this.state.errors.mrtn_yield_rep2}
                  label="Second replication">
                  <TextInput
                    onChange={this.onChange}
                    value={this.state.field.mrtn_yield_rep2}
                    name="mrtn_yield_rep2" />
                </FormField>
                <FormField label="Third replication">
                  <TextInput
                    onChange={this.onChange}
                    value={this.state.field.mrtn_yield_rep3}
                    name="mrtn_yield_rep3" />
                </FormField>
              </Box>
            </Section>
            <Footer pad={{ vertical: 'small' }} justify="between">
              <Button icon={submitting ? <Spinning /> : null} onClick={this.onSubmit} type="submit" primary label="Save Field" />
              <Button onClick={this.onReset} label="Clear Form" />
            </Footer>
          </Form>
        </Article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/FieldSubmission.js